module.exports = __webpack_public_path__ + "img/159.e1060717.png";